// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"OperatorWiseCurrencyPage_inputContainer__3bGrn"};